import React, { useRef, useState, useEffect } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Toastr from "toastr";

const CopyContent:React.FC<{
    subNode: any,
    match: RegExpExecArray,
    style: {
      [key: string]: React.CSSProperties;
    },
    properties: any,
    node:any
  }> = ({subNode, match, style, properties, node}) => {
    const [fullSize, setFullSize] = useState<boolean>(false);
    const handleClick = () => {
      setFullSize(!fullSize);
    };
    return <div id="box" className="code-block">
      <div id="icon">
        <CopyToClipboard onCopy={() => {
          Toastr.success("Copied successfully.")
        }} text={subNode}>
          <i className="ni ni-ungroup"></i>
        </CopyToClipboard>
      </div>
      <div>
        <SyntaxHighlighter
            children={String(subNode).replace(/\n$/, "")}
            language={match[1]}
            {...properties}
            style={oneDark}
          />
      </div>
        
      </div>
  };

  export default CopyContent;